exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/~/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = 0